import { Image } from '@chakra-ui/react';
import React from 'react';
import logo from '@/assets/oldgill/images/sideNav/logoSidenav.png';

export default function Index() {
  return <Image src={logo} maxW="157px" position="relative" top="0.5" />;
}
